import { montserratBold, montserratLight, montserratMedium, montserratNormal, montserratSemibold } from '@/assets/fonts/montserrat'
import Image from 'next/image'
import React from 'react'
import audit from "@/assets/reconciliation-automate/features/freya-audit.png"
import { CheckCircleIcon } from '@heroicons/react/24/outline'
import { t } from 'i18next'

export default function FeatureAudit() {
  return (
    <div className='flex relative w-full h-full p-8 bg-gray-cool-50 rounded-lg overflow-hidden'>
      <div className='border w-[460px] lg:w-[380px] h-fit overflow-hidden flex border-gray-cool-200 rounded-lg relative'>
        <Image src={audit}/>
      </div>
      <div className='pl-8 block w-auto'>
        <h3 className={`${montserratBold.className} text-gray-cool-700 text-[20px] lg:text-[24px] pb-6`}>{t('recon_feature_list_detail_title_2')}</h3>
        <ul className='block space-y-6 w-auto lg:w-[450px]'>
          <li className='flex justify-center space-x-3'>
            <span className='relative w-10 top-1 text-blue-primary-500'><CheckCircleIcon className='absolute'/></span>
            <p className={`${montserratLight.className} lg:text-[20px] text-gray-cool-500`}><span className={`${montserratMedium.className} text-gray-cool-700`}>{t('recon_feature_list_detail_description_2_bold_part_1')}</span>{t('recon_feature_list_detail_description_2_detail_part_1')}</p>
          </li>
          <li className='flex justify-center space-x-3'>
            <span className='relative w-10 top-1 text-blue-primary-500'><CheckCircleIcon className='absolute'/></span>
            <p className={`${montserratLight.className} lg:text-[20px] text-gray-cool-500`}><span className={`${montserratMedium.className} text-gray-cool-700`}>{t('recon_feature_list_detail_description_2_bold_part_2')}</span>{t('recon_feature_list_detail_description_2_detail_part_2')}</p>
          </li>
          <li className='flex justify-center space-x-3'>
            <span className='relative w-10 top-1 text-blue-primary-500'><CheckCircleIcon className='absolute'/></span>
            <p className={`${montserratLight.className} lg:text-[20px] text-gray-cool-500`}><span className={`${montserratMedium.className} text-gray-cool-700`}>{t('recon_feature_list_detail_description_2_bold_part_3')}</span>{t('recon_feature_list_detail_description_2_detail_part_3')}</p>
          </li>
        </ul>
      </div>
    </div>
  )
}
